import React from 'react';
import PropTypes from 'prop-types';
import { basePath } from '../../../services/utils';
import { CustomImage } from '../../../utils/common.styles';
import { ToggleSectionWrapper, ToggleSectionOptions } from './ToggleSection.styles';
import { SCOPE_TYPES } from '../../utils/utils';

const ToggleSection = props => {
    const { toggleLabels, contentScope, changeScope } = props;

    const onToggleClick = () => {
        switch (contentScope) {
            case SCOPE_TYPES.FIELDWORK_BPT:
                changeScope(SCOPE_TYPES.FIELDWORK_ADTESTER);
                break;
            case SCOPE_TYPES.FIELDWORK_ADTESTER:
                changeScope(SCOPE_TYPES.FIELDWORK_BPT);
                break;
            case SCOPE_TYPES.BPT_AXA:
                changeScope(SCOPE_TYPES.BPT_EVOLUTION);
                break;
            case SCOPE_TYPES.BPT_EVOLUTION:
                changeScope(SCOPE_TYPES.BPT_AXA);
                break;
            default:
                break;
        }
    };

    const leftSideScopes = [SCOPE_TYPES.FIELDWORK_ADTESTER, SCOPE_TYPES.BPT_AXA];
    const rightSideScopes = [SCOPE_TYPES.FIELDWORK_BPT, SCOPE_TYPES.BPT_EVOLUTION];
    const isFromBPT = contentScope === SCOPE_TYPES.BPT_AXA || contentScope === SCOPE_TYPES.BPT_EVOLUTION;

    return (
        <ToggleSectionWrapper isFromBPT={isFromBPT}>
            <ToggleSectionOptions
                style={{ fontWeight: leftSideScopes.some(scope => scope === contentScope) ? 'bold' : 'normal' }}
            >
                {' '}
                {toggleLabels.left}{' '}
            </ToggleSectionOptions>
            <CustomImage
                src={
                    rightSideScopes.some(scope => scope === contentScope)
                        ? `${basePath}/visuals/toggle-right.png`
                        : `${basePath}/visuals/toggle-left.png`
                }
                onClick={onToggleClick}
                cursor="pointer"
                position="relative"
                top="7px"
                width="36px"
                padding="0 5px"
                alt={toggleLabels.imageAlt}
            />

            <ToggleSectionOptions
                style={{ fontWeight: rightSideScopes.some(scope => scope === contentScope) ? 'bold' : 'normal' }}
            >
                {' '}
                {toggleLabels.right}{' '}
            </ToggleSectionOptions>
        </ToggleSectionWrapper>
    );
};

ToggleSection.propTypes = {
    contentScope: PropTypes.string.isRequired,
    toggleLabels: PropTypes.shape({
        left: PropTypes.string,
        right: PropTypes.string,
        imageAlt: PropTypes.string,
    }).isRequired,
    changeScope: PropTypes.func.isRequired,
};

export default ToggleSection;
